<template>
    <div class="chat__bottom">
        <form @submit.prevent="submit()">
            <div class="chat__inputbox">
                <textarea v-model.trim="text"
                          class="chat__input r-text-input textarea"
                          placeholder="Напишите текст сообщения..."
                          @keyup.enter.exact="submit()"
                          @keyup.shift.enter.exact="addLineBreak()"
                          @keyup.ctrl.enter.exact="addLineBreak()"
                          required></textarea>
            </div>
            <button class="chat__enter r-button button">Отправить сообщение</button>
        </form>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';

    export default {
        data() {
            return {
                text: '',
            }
        },
        computed: {
            ...mapState([
                'consultation',
                'user',
            ]),
        },
        methods: {
            ...mapActions('chat', [
                'sendMessage',
            ]),
            submit() {
                if (!this.text) {
                    return false;
                }

                this.sendMessage({
                    text: this.text,
                });

                this.text = '';
            },
			addLineBreak() {
				this.text = this.text + "\n";
			}
        }
    }
</script>
